import { useMemo } from "react";
import Svg, { Path } from "react-native-svg";
import { Platform, View } from "react-native";

import type { IconProps } from "./types";
export function Calendar({
  size = 24,
  color,
  style,
  ...props
}: Omit<IconProps, "width" | "height" | "viewBox" | "fill">) {
  const defaultColor = useMemo(
    () => (Platform.OS === "web" ? "currentcolor" : "black"),
    []
  );
  const component = (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ? color : defaultColor}
      {...props}
    >
      <Path
        d="M8.666 11.802H6.328v2.407h2.338v-2.407zm.6-1.005c.1 0 .196.04.267.113.07.073.11.172.11.275v3.64c0 .103-.04.201-.11.274a.372.372 0 01-.267.114H5.728c-.1 0-.196-.04-.267-.114a.394.394 0 01-.11-.274v-3.64c0-.103.04-.202.11-.275a.372.372 0 01.267-.114h3.538zm10.3-7.316c.792 0 1.434.66 1.434 1.476v15.567c0 .815-.642 1.476-1.435 1.476H4.435c-.38 0-.746-.155-1.015-.432A1.498 1.498 0 013 20.524V4.957c0-.815.642-1.476 1.435-1.476h1.36v-.978c0-.278.22-.503.489-.503.27 0 .488.225.488.503v.978h10.92v-.978c0-.278.219-.503.489-.503s.488.225.488.503v.978h.896zM4.434 4.486a.465.465 0 00-.458.471v3.838h16.046V4.957c0-.26-.205-.47-.458-.471H4.435zm15.13 16.509a.465.465 0 00.458-.471V9.8H3.977v10.724c0 .26.205.47.458.47h15.13z"
        fill={color ? color : defaultColor}
      />
    </Svg>
  );

  if (style) {
    return <View style={style}>{component}</View>;
  }

  return component;
}
